<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">
    <div
      :class="classObj"
      class="vx-navbar-wrapper"
    >
      <vs-navbar
        :color="navbarColorLocal"
        :class="textColor"
        class="vx-navbar navbar-custom navbar-skelton"
      >
        <div v-if="activeAccount.isPrivateSession"><a href="https://calendar.app.google/8e7tS6mk7VCfEvu8A" target="_blank">個別説明会を依頼</a></div>
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <span @click.stop="showSidebar">
          <VueFeather
            type="menu"
            class="sm:inline-flex xl:hidden cursor-pointer p-2 feather-icon"
          />
        </span>
        <vs-spacer />
        <account-drop-down />
        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AccountDropDown from './components/AccountDropDown.vue'
import ProfileDropDown from './components/ProfileDropDown.vue'

export default {
  name: 'TheNavbarVertical',
  components: {
    AccountDropDown,
    ProfileDropDown
  },
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  computed: {
    ...mapState('account', ['activeAccount']),
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
      else                                              return null
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

